import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const notificationTypesSchema = buildSchema({
    name: "Notification Types",
    properties: {
        title: buildProperty({
            title: "Title",
            validation: { required: true },
            dataType: "string",
        }),
        description: buildProperty({
            title: "Description",
            validation: { required: true },
            dataType: "string"
        }),
        key: buildProperty({
            title: "Key",
            validation: { required: true },
            dataType: "string",
            readOnly: true,
            config: {
                enumValues: {
                    generalNotification: "General Notification",
                    communityNotification: "Community Notification",
                    sessionNotification: "Session Notification",
                }
            }
        }),
    },
    defaultValues: {
        key: "onGeneralMessage"
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
